import { makeHeadingElementKey } from '../../../utils/heading-structure-utils';
import { ElementStatus } from '../../rule-element/types';
/**
 * Resolves the status shown for a heading row in the AI flow.
 *
 * - Non-generic heading with an AI suggestion → always `Generated` (the AI
 *   auto-fixes it on apply, so it is shown as green).
 * - Generic heading with an AI suggestion → keeps its real `status` (green or
 *   red). The generic flow is manual and nothing is auto-applied, so the
 *   optimistic preview is intentionally skipped; the sparkle icon is what
 *   signals that a suggestion exists.
 * - No suggestion → the rule-checker preview status, falling back to the
 *   heading's own `status`.
 */
export const resolveDisplayedStatus = (heading, aiSuggestedKeys, previewStatusById) => {
  const hasSuggestion = aiSuggestedKeys.has(makeHeadingElementKey(heading.componentId, heading.attributeId, heading.elementId));
  if (hasSuggestion && !heading.isGeneric) {
    return ElementStatus.Generated;
  }
  if (hasSuggestion && heading.isGeneric) {
    return heading.status;
  }
  return previewStatusById.get(heading.elementId) ?? heading.status;
};
//# sourceMappingURL=resolve-displayed-status.js.map